<template>
	<div>
		<el-dialog title="建联记录" :visible.sync="dialogVisible" append-to-body width="520px" :before-close="handleClose">
			<el-form :model="form" :rules="rules" ref="ruleForm" label-width="82px">
				<el-form-item label="建联时间" prop="operate_time">
					<el-date-picker type="datetime" placeholder="请选择时间" v-model="form.operate_time" value-format="timestamp" />
				</el-form-item>
				<el-form-item label="建联结果">
					<el-radio-group v-model="form.is_pass">
						<el-radio :label="1">微信已通过</el-radio>
						<el-radio :label="2">微信未通过</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button type="primary" @click="submit">确 定</el-button>
			</span>
		</el-dialog>
		<linkman-dialog ref="linkmanDialog" @getList="getList" />
	</div>
</template>

<script>
import { talentContact } from '@/api/talentCRM';
import linkmanDialog from '../linkmanDialog';

export default {
	name: 'buildContactDialog',
	components: {
		linkmanDialog,
	},
	data() {
		return {
			dialogVisible: false,
			row: {},
			form: {
				anchor_id: '',
				operate_time: '',
				is_pass: 1,
				contact_type: 1,
			},
			rules: {
				operate_time: { required: true, message: '请选择建联时间', trigger: 'change' },
			},
		};
	},
	methods: {
		show(row) {
			this.row = row;
			this.form.anchor_id = row.anchor_id;
			this.form.operate_time = Date.now();
			this.dialogVisible = true;
		},
		handleClose() {
			this.dialogVisible = false;
			this.row = {};
			this.form = {
				anchor_id: '',
				operate_time: '',
				is_pass: 1,
				contact_type: 1,
			};
			this.$refs.ruleForm.resetFields();
		},
		submit() {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				const { form } = this;
				if (form.is_pass === 1) {
					this.$refs.linkmanDialog.show({ ...form }, this.row);
					return this.handleClose();
				}
				const { code } = await talentContact({ ...form, operate_time: Math.trunc(form.operate_time / 1000) });
				if (code !== 0) return;
				this.$message.success('设置成功');
				this.getList();
				this.handleClose();
			});
		},
		getList() {
			this.$emit('getList');
		},
	},
};
</script>

<style lang="less" scoped></style>
